$(document).ready(function () {
  // obecne
  let bodyWidth = window.innerWidth;
  var bookButton = $('.js-open-villa-date');

  // události při resize okna
  $(window).on('resize', function () {
    // osetreni, zda se velikost zmenila
    if (bodyWidth !== window.innerWidth) {
      // nastavíme novou šířku
      bodyWidth = window.innerWidth;
      // zresetuj menu
      resetMenu();
    }
  });

  // mobilní menu
  function switchMenu() {
    // označíme zda je menu zavřeno či nikoliv
    if ($('.nav-switcher').hasClass('is-open')) {
      $('.nav-switcher, .nav').removeClass('is-open');
      $('body').removeClass('is-unscrollable');
    } else {
      $('.nav-switcher, .nav').addClass('is-open');
      $('body').addClass('is-unscrollable');
    }
  }
  // při změně rozlišení resetujeme menu
  function resetMenu() {
    $('.nav-switcher, .nav').removeClass('is-open');
    $('body').removeClass('is-unscrollable');
  }
  // spouštěč
  $('.nav-switcher').on('click', function () {
    switchMenu();
  });

  // události při načtení stránky
  $(window).on('load', function () {
    // AOS fix pro první načítání
    AOS.refresh();
    // setTimeout(function () {
    //   $('.select-items').each(function (i) {
    //     new SimpleBar($('.select-items')[i], { autoHide: false });
    //   });
    // }, 500);
  });

  // události při scroolování
  $(window).on('scroll', function () {
    if ($('.js-footer-cta').length) {
      footerMobileCta();
    }
  });

  // modal okna
  if ($('.modal').length) {
    modal();
  }

  // youtube video v modálním okně
  if ($('.js-video-start').length) {
    //new ModalVideo('.js-video-start', { channel: 'youtube' });
    $('.js-video-start').modalVideo({
      youtube: {
        controls: 1,
        autoplay: 1,
      },
    });
  }

  // galerie
  // if ($('.js-gallery').length) {
  //   $('.js-gallery a').simpleLightbox({
  //     showCounter: false,
  //   });
  // }
  if ($('.js-gallery').length > 0) {
    let $images = $('.js-gallery a');
    let $imagesGrouped = $images.filter('[data-group]');
    let $imagesAlone = $images.not($imagesGrouped);
    let params = {
      showCounter: false,
    };

    // Handle standalone images
    $imagesAlone.each(function (index, element) {
      $(element).simpleLightbox(params);
    });

    // Handle grouped imags
    if ($imagesGrouped.length > 0) {
      // Select all groups
      let groupNames = $imagesGrouped
        .map(function () {
          return $(this).data('group');
        })
        .get();
      groupNames = $.unique(groupNames);

      // Apply on each group
      $.each(groupNames, function (key, value) {
        $imagesGrouped
          .filter(function () {
            return $(this).data('group') == value;
          })
          .simpleLightbox(params);
      });
    }
  }

  let dateDayStart = document.querySelectorAll('.date--day--start');
  let dateMonthStart = document.querySelectorAll('.date--month--start');
  let dateDayEnd = document.querySelectorAll('.date--day--end');
  let dateMonthEnd = document.querySelectorAll('.date--month--end');

  if (IChorvatsko.dateFrom !== '' && IChorvatsko.dateTo !== '') {
    let momentDateFrom = moment(IChorvatsko.dateFrom, 'DD.MM.YYYY');
    let momentDateTo = moment(IChorvatsko.dateTo, 'DD.MM.YYYY');
    setDateDetailVilla(momentDateFrom, momentDateTo);
  }

  var picker;
  if (IChorvatsko.dateFrom === '' && IChorvatsko.dateTo === '') {
    picker = $('.villa-date')
      .daterangepicker(
        {
          minDate: moment().add(1, 'day'),
          autoApply: true,
          drops: 'auto',
          locale: {
            format: 'DD/MM/YYYY',
            daysOfWeek: ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'],
            monthNames: [
              'Leden',
              'Únor',
              'Březen',
              'Duben',
              'Květen',
              'Červen',
              'Červenec',
              'Srpen',
              'Září',
              'Říjen',
              'Listopad',
              'Prosinec',
            ],
          },
        },
        function (start, end) {
          setDateDetailVilla(start, end);
        }
      )
      .data('daterangepicker');
    if (typeof picker !== 'undefined') {
      picker.container.addClass('datepicker-custom-center');
    }
  } else {
    picker = $('.villa-date')
      .daterangepicker(
        {
          startDate: moment(IChorvatsko.dateFrom, 'DD.MM.YYYY'),
          endDate: moment(IChorvatsko.dateTo, 'DD.MM.YYYY'),
          minDate: moment().add(1, 'day'),
          autoApply: true,
          drops: 'auto',
          locale: {
            format: 'DD/MM/YYYY',
            daysOfWeek: ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'],
            monthNames: [
              'Leden',
              'Únor',
              'Březen',
              'Duben',
              'Květen',
              'Červen',
              'Červenec',
              'Srpen',
              'Září',
              'Říjen',
              'Listopad',
              'Prosinec',
            ],
          },
        },
        function (start, end) {
          setDateDetailVilla(start, end);
        }
      )
      .data('daterangepicker');
    if (typeof picker !== 'undefined') {
      picker.container.addClass('datepicker-custom-center');
    }
  }

  if ($('.js-open-villa-date').length > 0) {
    $('.js-open-villa-date').on('click', function () {
      document.querySelector('.villa-date').click();
    });
  }

  if (IChorvatsko.dateFrom === '' && IChorvatsko.dateTo === '') {
    picker = $('.villa-date-modal')
      .daterangepicker(
        {
          minDate: moment().add(1, 'day'),
          autoApply: true,
          drops: 'auto',
          locale: {
            format: 'DD/MM/YYYY',
            daysOfWeek: ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'],
            monthNames: [
              'Leden',
              'Únor',
              'Březen',
              'Duben',
              'Květen',
              'Červen',
              'Červenec',
              'Srpen',
              'Září',
              'Říjen',
              'Listopad',
              'Prosinec',
            ],
          },
        },
        function (start, end) {
          setDateDetailVilla(start, end);
        }
      )
      .data('daterangepicker');
    if (typeof picker !== 'undefined') {
      picker.container.addClass('datepicker-custom-center');
    }
  } else {
    picker = $('.villa-date-modal')
      .daterangepicker(
        {
          startDate: moment(IChorvatsko.dateFrom, 'DD.MM.YYYY'),
          endDate: moment(IChorvatsko.dateTo, 'DD.MM.YYYY'),
          minDate: moment().add(1, 'day'),
          autoApply: true,
          drops: 'auto',
          locale: {
            format: 'DD/MM/YYYY',
            daysOfWeek: ['Po', 'Út', 'St', 'Čt', 'Pá', 'So', 'Ne'],
            monthNames: [
              'Leden',
              'Únor',
              'Březen',
              'Duben',
              'Květen',
              'Červen',
              'Červenec',
              'Srpen',
              'Září',
              'Říjen',
              'Listopad',
              'Prosinec',
            ],
          },
        },
        function (start, end) {
          setDateDetailVilla(start, end);
        }
      )
      .data('daterangepicker');
    if (typeof picker !== 'undefined') {
      picker.container.addClass('datepicker-custom-center');
    }
  }

  if ($('.js-open-villa-date-modal').length > 0) {
    $('.js-open-villa-date-modal').on('click', function () {
      document.querySelector('.villa-date-modal').click();
    });
  }

  function setDateDetailVilla(start, end) {
    let startWithFormat = start.format('DD.MM.YYYY');
    let endWithFormat = end.format('DD.MM.YYYY');

    if ($('.form--date--start').length > 0) {
      document.querySelector('.form--date--start').value = startWithFormat;
    }
    if ($('.form--date--end').length > 0) {
      document.querySelector('.form--date--end').value = endWithFormat;
    }
    // dateDayStart.innerHTML = start.format('DD');
    dateDayStart.forEach((e) => (e.innerHTML = start.format('DD')));
    // dateMonthStart.innerHTML = start.format('MM');
    dateMonthStart.forEach((e) => (e.innerHTML = start.format('MM')));
    // dateDayEnd.innerHTML = end.format('DD');
    dateDayEnd.forEach((e) => (e.innerHTML = end.format('DD')));
    // dateMonthEnd.innerHTML = end.format('MM');
    dateMonthEnd.forEach((e) => (e.innerHTML = end.format('MM')));
    if (document.body.contains(document.querySelector('.date .is-anytime'))) {
      document.querySelector('.date .is-anytime').remove();
    }
    if (document.body.contains(document.querySelector('.date .is-selected'))) {
      document
        .querySelector('.date .is-selected')
        .classList.remove('is-selected');
    }
    let url = bookButton.data('url');
    $.ajax({
      type: 'POST',
      url: url,
      dataType: 'json',
      data: { dateFrom: startWithFormat, dateTo: endWithFormat },
      success: function (data) {},
    });
  }

  // pin pointer zobrazoání detailu na mapě
  if ($('.pin').length) {
    $('.pin').on('click', function () {
      if ($(this).hasClass('is-open')) {
        $(this).removeClass('is-open');
      } else {
        $('.pin').removeClass('is-open');
        $(this).addClass('is-open');
      }
    });
  }

  // zamezení nechtěného scrollování v mapě... začne scrollovat v mapě až po kliku do mapy
  if ($('.map').length) {
    $('.map__overlay').click(function () {
      $(this).addClass('is-hidden');
    });
  }
});

// AOS fix při kliknutí na tlačítko zpět
// source: https://mymonkeydo.com/onload-event-when-back-button-is-pressed/
history.navigationMode = 'compatible';
$(document).ready(function () {
  AOS.refresh();
});
